// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"71affc1f","703":"f07f4a6f"}[chunkId] + ".chunk.js";
};